import React from 'react'
import {EnrollmentReasonInfo} from '../../../DTO/BucketHeader'
import {Optional} from '../../../../Common/TypeHelper'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {MBMemberSelect} from '../../Atoms/MBMemberSelect'
import {ErrorDisplay} from '../../Molecules/ErrorsAndAlert/ErrorDisplay'
import {useTranslation} from 'react-i18next'

export type EnrollmentReasonSelectedInfo = {
  bucketId: number
  enrollmentReasonId: Optional<number>
}

type EnrollmentReasonSelectContentBlockProps = {
  enrollmentReasonInfoList: Optional<EnrollmentReasonInfo[]>
  enrollmentReasonSelectedInfo: Optional<EnrollmentReasonSelectedInfo>
  onChange: (enrollmentReasonSelectedInfo: EnrollmentReasonSelectedInfo) => void
  errorMessages: string[]
}
export const EnrollmentReasonSelectContentBlock:
  React.VFC<EnrollmentReasonSelectContentBlockProps> = (
  {
    enrollmentReasonInfoList,
    enrollmentReasonSelectedInfo,
    onChange,
    errorMessages,
  },
) => {
  const {t} = useTranslation('member')

  if (!enrollmentReasonInfoList
    || enrollmentReasonInfoList.length === 0
    || !enrollmentReasonSelectedInfo) {
    return <></>
  }

  return (
    <PIMCard
      headerProps={{title: t('新規登録情報入力.入会動機選択.見出し'), require: true}}
      testId={'selector-enrollment-reason-content-block'}
    >
      <MBMemberSelect
        name={'enrollmentReason'}
        value={enrollmentReasonSelectedInfo?.enrollmentReasonId}
        hasError={errorMessages.length > 0}
        onChange={(e): void => {
          const targetValueNum = Number(e.target.value)
          onChange({
            ...enrollmentReasonSelectedInfo,
            enrollmentReasonId: targetValueNum,
          })
        }}
      >
        <option value={''} hidden>{'選択してください'}</option>
        {enrollmentReasonInfoList.map(enrollmentReasonInfo => (
          <option key={enrollmentReasonInfo.id} value={enrollmentReasonInfo.id}>
            {enrollmentReasonInfo.label}
          </option>
        ))}
      </MBMemberSelect>
      <ErrorDisplay errors={errorMessages}/>
    </PIMCard>
  )
}
